import {State, USER_SELECTION_STATUS} from '../state';
import {createSelector, MemoizedSelector} from '@ngrx/store';
import {selectBpmnProcessState} from './bpmn-process-state.selector';

const getUserSelectionStatus = (state: State): any => state.handelingUserSelectionStatus;

const getUserSelectionInProgress = (state: State): any => state.handelingUserSelectionStatus === USER_SELECTION_STATUS.InProgress;

export const selectGetUserSelectionStatus: MemoizedSelector<object, USER_SELECTION_STATUS> =
  createSelector(selectBpmnProcessState, getUserSelectionStatus);


export const selectUserSelectionInProgress: MemoizedSelector<object, boolean> =
  createSelector(selectBpmnProcessState, getUserSelectionInProgress);
